module.exports = __webpack_public_path__ + "img/2f_r_sobaichi@2x.5c91dd4f.jpg";